import { createFileRoute } from '@tanstack/react-router'
import { ContactScreen } from '../features/directory/screens'

export const Route = createFileRoute('/contacts/$id')({
  component: ContactRoute,
})

function ContactRoute() {
  const { id } = Route.useParams()
  return <ContactScreen id={id} />
}
